var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 17.87l-2.99-3c-.51.67-1.1 1.26-1.77 1.77l3 3a1.25 1.25 0 001.76 0c.5-.5.5-1.29 0-1.77zM8.75 17.5a8.76 8.76 0 010-17.5 8.76 8.76 0 010 17.5zm0-15a6.26 6.26 0 10.01 12.51A6.26 6.26 0 008.75 2.5z",
    fill: "#00F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwRiIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMTkuNjMgMTcuODdsLTIuOTktM2MtLjUxLjY3LTEuMSAxLjI2LTEuNzcgMS43N2wzIDNhMS4yNSAxLjI1IDAgMDAxLjc2IDBjLjUtLjUuNS0xLjI5IDAtMS43N3pNOC43NSAxNy41YTguNzYgOC43NiAwIDAxMC0xNy41IDguNzYgOC43NiAwIDAxMCAxNy41em0wLTE1YTYuMjYgNi4yNiAwIDEwLjAxIDEyLjUxQTYuMjYgNi4yNiAwIDAwOC43NSAyLjV6Ii8+PC9nPjwvc3ZnPg==";
export { SvgMagnifyingGlass as ReactComponent };